
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaionlinecabbooking() {



    const cardData =
    {
        keyword: 'Mumbai Online Cab Booking',
        heading: 'S9 Travels: Mumbai Online Cab Booking',
        headingDescription: 'S9 Travels offers Mumbai Online Cab Booking, making your travel easy, reliable, and hassle-free. Whether you need a cab for airport transfers, outstation trips, corporate travel, or city rides, our Innova cabs ensure a smooth and comfortable journey. With spacious interiors, luxury features, and professional drivers, we guarantee on-time service and a stress-free experience. Enjoy affordable fares, 24/7 availability, and instant online booking. Choose S9 Travels for a seamless Mumbai cab booking experience!',


        top: 'Top Places to Visit in Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "An iconic monument overlooking the Arabian Sea, the Gateway of India is a historical landmark and a popular tourist attraction in Mumbai."
    },
    {
      "title": "Marine Drive",
      "description": "A scenic boulevard along the coastline, Marine Drive is perfect for evening walks, offering stunning sunset views and a lively atmosphere."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
      "description": "A UNESCO World Heritage Site, CST is an architectural marvel known for its Victorian-Gothic style and historical significance."
    },
    {
      "title": "Elephanta Caves",
      "description": "Located on Elephanta Island, these ancient rock-cut caves house intricate sculptures of Lord Shiva and are a UNESCO World Heritage Site."
    },
    {
      "title": "Juhu Beach",
      "description": "A famous beach in Mumbai, Juhu Beach is known for its street food stalls, vibrant atmosphere, and stunning sea views."
    },
    {
      "title": "Colaba Causeway",
      "description": "A bustling shopping street, Colaba Causeway is perfect for picking up souvenirs, fashion accessories, and enjoying cafes and restaurants."
    },
    {
      "title": "Siddhivinayak Temple",
      "description": "One of Mumbai’s most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "A beautiful mosque and dargah located on a small island off the coast of Worli, Haji Ali Dargah is a spiritual and architectural wonder."
    },
    {
      "title": "Film City",
      "description": "A must-visit for Bollywood fans, Film City offers guided tours where visitors can see film sets and experience the magic of Indian cinema."
    },
    {
      "title": "Sanjay Gandhi National Park",
      "description": "A lush green national park within the city, it is home to the ancient Kanheri Caves, nature trails, and diverse wildlife."
    }
],

"services": [
    {
      "name": "Mumbai Online Cab Booking",
      "description": "Book your cab online with S9 Travels for a seamless and convenient ride in Mumbai. Our online booking system ensures you get a taxi at your fingertips, anytime, anywhere in the city."
    },
    {
      "name": "Book Cabs Online in Mumbai",
      "description": "Easily book cabs online in Mumbai with S9 Travels. Whether you need a taxi for a quick trip or a day-long journey, our online booking platform makes it simple and fast."
    },
    {
      "name": "Affordable Taxi Service in Mumbai Online",
      "description": "Get an affordable taxi service in Mumbai by booking online with S9 Travels. Our competitive rates ensure that you travel in comfort without breaking the bank."
    },
    {
      "name": "Mumbai Online Taxi Reservations",
      "description": "Reserve your taxi online in Mumbai with S9 Travels. Our quick and easy reservation process guarantees a smooth travel experience from start to finish."
    },
    {
      "name": "Private Online Cab Booking for Mumbai",
      "description": "For a more personalized travel experience, book a private cab online in Mumbai with S9 Travels. Enjoy a comfortable ride with professional drivers who prioritize your convenience."
    },
    {
      "name": "Mumbai Taxi Service for All Needs",
      "description": "S9 Travels offers a versatile taxi service for all your needs in Mumbai. From business trips to family outings, our online booking system allows you to find the perfect ride for any occasion."
    },
    {
      "name": "Book Mumbai Taxi Through App",
      "description": "Download our app and book a taxi in Mumbai instantly. Whether you're traveling for business or leisure, S9 Travels provides quick and reliable taxi services with just a few taps."
    },
    {
      "name": "Mumbai Airport Taxi Online Booking",
      "description": "Book your airport taxi in Mumbai online with S9 Travels. We provide prompt, reliable, and comfortable airport transfers for a hassle-free start or end to your journey."
    },
    {
      "name": "Instant Online Cab Booking for Mumbai",
      "description": "Need a cab urgently? Use S9 Travels' instant online cab booking service in Mumbai. Get a ride at your convenience, no matter the time of day or night."
    },
    {
      "name": "Online Taxi Service for Sightseeing in Mumbai",
      "description": "Explore the sights of Mumbai with our online taxi booking service. Whether it’s a visit to the Gateway of India, Marine Drive, or other famous landmarks, we provide comfortable rides for your sightseeing tour."
    },
    {
      "name": "Professional Online Cab Booking in Mumbai",
      "description": "Book your professional taxi online in Mumbai with S9 Travels. Our well-trained drivers and premium vehicles ensure a smooth and professional ride every time."
    }
],

"tableData": [
  ["Mumbai Online Cab Booking", "Book Cabs Online in Mumbai"],
  ["Affordable Taxi Service in Mumbai Online", "Mumbai Online Taxi Reservations"],
  ["Private Online Cab Booking for Mumbai", "Mumbai Taxi Service for All Needs"],
  ["Book Mumbai Taxi Through App", "Mumbai Airport Taxi Online Booking"],
  ["Instant Online Cab Booking for Mumbai", "Online Taxi Service for Sightseeing in Mumbai"],
  ["Professional Online Cab Booking in Mumbai", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Convenient Online Booking Process",
    "WhyChoosedescription": "S9 Travels offers a simple and convenient online cab booking service in Mumbai. With just a few clicks on our website or mobile app, you can easily book your ride, ensuring a hassle-free experience every time."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Whether you need a small sedan for a quick trip or a spacious SUV like the Toyota Innova for a family outing, S9 Travels offers a wide variety of vehicles for online booking in Mumbai. Choose the vehicle that best fits your needs and preferences."
  },
  {
    "WhyChooseheading": "Timely and Reliable Service",
    "WhyChoosedescription": "Booking a cab online with S9 Travels guarantees punctual and reliable service. Once you book your ride, our professional drivers ensure timely pick-up and drop-off, so you can reach your destination on time without any stress."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive rates for all online bookings. Our pricing is transparent with no hidden charges. You’ll get a clear breakdown of the cost when booking your ride, so you can plan your travel budget accordingly."
  },
  {
    "WhyChooseheading": "Safety and Comfort at Your Fingertips",
    "WhyChoosedescription": "When you book a cab online with S9 Travels, you can expect a safe and comfortable journey. Our cabs are equipped with modern safety features like GPS tracking, airbags, and seat belts, ensuring that you travel securely throughout your trip."
  },
  {
    "WhyChooseheading": "24/7 Availability for Any Occasion",
    "WhyChoosedescription": "S9 Travels offers 24/7 availability for all online cab bookings in Mumbai. Whether you need a cab early in the morning, late at night, or anytime in between, we are here to ensure you have access to a ride whenever you need it."
  },
  {
    "WhyChooseheading": "Instant Booking Confirmation",
    "WhyChoosedescription": "When you book your Mumbai cab online with S9 Travels, you receive instant booking confirmation, giving you peace of mind. You’ll know exactly when your cab will arrive and have all the details you need for a smooth experience."
  },
  {
    "WhyChooseheading": "Customizable Travel Options",
    "WhyChoosedescription": "Booking online with S9 Travels also allows you to customize your ride. Whether you need additional stops or a specific route, we offer flexibility in your online booking, tailoring your trip to your exact needs and preferences."
  }
]











    }


    const faqData = [
        [
          {
            question: 'How can I book a cab online with S9 Travels in Mumbai?',
            answer: 'Booking a cab with S9 Travels in Mumbai is easy! You can book your ride through our website or mobile app. Simply enter your pickup and drop-off locations, choose your vehicle, and confirm your booking. Our customer service team is also available for assistance if needed.',
          },
          {
            question: 'What types of cabs can I book online in Mumbai?',
            answer: 'We offer a variety of vehicles for online bookings, including sedans, SUVs, and premium options like the Toyota Innova. You can choose a vehicle based on your needs, whether it’s a solo trip or a group outing.',
          },
          {
            question: 'How do I make payment for an online cab booking in Mumbai?',
            answer: 'For online cab bookings in Mumbai, you can make payment via multiple options: credit/debit cards, UPI, or online payment through our mobile app. You can also pay in cash directly to the driver at the end of your trip.',
          },
          {
            question: 'Can I book a cab for a round trip online in Mumbai?',
            answer: 'Yes, you can easily book a round-trip cab online. Simply provide your return details when booking, and we will ensure your cab is available for both the onward and return journeys at the scheduled times.',
          },
          {
            question: 'Are there any extra charges for booking a cab online in Mumbai?',
            answer: 'The fare for online cab bookings in Mumbai is calculated based on your route, trip duration, and vehicle type. Any additional charges, such as waiting time or detours, will be communicated to you upfront during the booking process.',
          },
          {
            question: 'Can I book an airport cab online in Mumbai?',
            answer: 'Yes, you can easily book an airport cab online for both pickup and drop-off at Mumbai’s Chhatrapati Shivaji Maharaj International Airport (BOM). Our drivers will ensure a smooth transfer, with real-time updates on your ride.',
          },
          {
            question: 'Is there a fixed fare for online cab bookings in Mumbai?',
            answer: 'The fare for online cab bookings in Mumbai depends on factors like vehicle type, trip duration, and the route taken. Contact us for a customized quote based on your specific needs.',
          },
          {
            question: 'Can I cancel my online cab booking in Mumbai?',
            answer: 'Yes, you can cancel your online booking through our website or app. Please review our cancellation policy for any applicable charges, depending on how much notice you give before canceling.',
          },
          {
            question: 'Why should I choose S9 Travels for my online cab booking in Mumbai?',
            answer: 'S9 Travels offers reliable, affordable, and safe online cab booking services in Mumbai. With well-maintained vehicles, professional drivers, and excellent customer service, we ensure a hassle-free experience for every ride.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Kunal Mehta',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Booking a cab online with S9 Travels was incredibly easy. The website was user-friendly, and the booking process was smooth. The driver was on time and the vehicle was very comfortable. Highly recommend S9 Travels for anyone in Mumbai looking for reliable cab services.”',
        },
        {
          name: 'Mrs. Shilpa Verma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab online with S9 Travels for a trip around Mumbai, and I had a fantastic experience. The cab was clean, the driver was polite, and the trip was seamless. It was so convenient to book online, and I’ll definitely use their service again!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai Online Cab Booking",
        "description": "Book cabs online in Mumbai for airport transfers, sightseeing tours, and daily commutes. S9 Travels offers affordable and professional online taxi booking services for all your needs, including instant reservations and private cab bookings through the app.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      


    return (
        <div>
         <Helmet>
        <title>Mumbai Online Cab Booking | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book cabs online in Mumbai for all your transportation needs. Affordable and professional taxi services, including airport transfers, sightseeing tours, and private bookings through the app, with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/57.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaionlinecabbooking;